export const doctorProfileActions = {
  FETCH_DOCTOR: {
    REQUEST: 'profile/fetchDoctorRequest',
    SUCCESS: 'profile/fetchDoctorSuccess',
    FAILURE: 'profile/fetchDoctorFailure'
  },
  UPDATE_DOCTOR: {
    REQUEST: 'profile/updateDoctorRequest',
    SUCCESS: 'profile/updateDoctorSuccess',
    FAILURE: 'profile/updateDoctorFailure'
  },
  COMPLETE_DOCTOR: {
    REQUEST: 'profile/completeDoctorRequest',
    SUCCESS: 'profile/completeDoctorSuccess',
    FAILURE: 'profile/completeDoctorFailure'
  }
};
